import { configureStore } from '@reduxjs/toolkit';
import { auth, token } from '../models/auth/auth.models';
import storage from 'redux-persist/lib/storage';
import persistReducer from 'redux-persist/es/persistReducer';
import rootReducer from '../reducer/rootReducer';
import persistStore from 'redux-persist/es/persistStore';
import { EmpresasState } from '../reducer/empresasReducer/empresas.reducer';

export interface AppStore {
      auth: auth,
      token: token,
      empresas: EmpresasState
};

/*
  dentro de blacklist declararemos todos los reducers que no deban de mantenerse persistentes,
  ejemplo: listas de usuarios, los que si deberán de ir persistentes serán: catálogos, configuraciones
*/
const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['']
};

const persistedReducers = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});

const persistor = persistStore(store);

export { store, persistor };
